'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useContext, useState } from 'react';

type GraphFiltersContextValue = {
  showTechnologies: boolean;
  showRepositories: boolean;
  setShowTechnologies: (showTechnologies: boolean) => void;
  setShowRepositories: (showRepositories: boolean) => void;
};

const GraphFiltersContext = createContext<GraphFiltersContextValue | undefined>(
  undefined,
);

export const GraphFiltersProvider = ({ children }: PropsWithChildren) => {
  const [showTechnologies, setShowTechnologies] = useState(true);
  const [showRepositories, setShowRepositories] = useState(true);

  return (
    <GraphFiltersContext.Provider
      value={{
        showTechnologies,
        showRepositories,
        setShowTechnologies,
        setShowRepositories,
      }}
    >
      {children}
    </GraphFiltersContext.Provider>
  );
};

export const useGraphFilters = (): GraphFiltersContextValue => {
  const context = useContext(GraphFiltersContext);
  if (!context) {
    throw new Error(
      'useGraphFilters must be used within a GraphFiltersProvider',
    );
  }
  return context;
};
